module.exports = __webpack_public_path__ + "static/img/jd1.3373f27e.png";